export enum CountDecksOnPage {
  Five = 5,
  Ten = 10,
  Twenty = 20,
  Fourty = 40,
}
